// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2020":"b00f302d47dc3cd4","2888":"0db39e7a9bbfde2d"}[chunkId] + ".css";
};